import { applyMiddleware } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import authReducer from "../reducers/authSlice";
import generalReducer from "../reducers/generalSlice";
const middleware = [thunk];

export const store = configureStore(
  {
    reducer: {
      auth: authReducer,
      general: generalReducer,
    },
  },
  applyMiddleware(...middleware)
);
